var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { ExerciseProgramLiteDto } from '../../exercise-programs/dtos/exercise-program.lite.dto.js';
import { UserFullSizeDto } from '../../user/index.js';
import { TrainingSessionItemFullSizeDto } from './training-session-item.full-size.dto.js';
export class TrainingSessionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    exerciseProgramId;
    started;
    ended;
    evalNotes;
    evalMood;
    difficulty;
    evaluated;
    exerciseProgram;
    trainingSessionItems = [];
    notificationTime;
    reviewedByTherapistId;
    reviewedByTherapist;
    reviewedByTherapistAt;
    userId;
    user;
    get userOfficeId() {
        return this.exerciseProgram.user?.officeId;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionFullSizeDto.prototype, "exerciseProgramId", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "started", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "ended", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "evalNotes", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "evalMood", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "difficulty", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "evaluated", void 0);
__decorate([
    IsObject(),
    Type(() => ExerciseProgramLiteDto),
    Expose(),
    __metadata("design:type", Function)
], TrainingSessionFullSizeDto.prototype, "exerciseProgram", void 0);
__decorate([
    IsArray(),
    Type(() => TrainingSessionItemFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], TrainingSessionFullSizeDto.prototype, "trainingSessionItems", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "notificationTime", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "reviewedByTherapistId", void 0);
__decorate([
    IsObject(),
    Type(() => UserFullSizeDto),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "reviewedByTherapist", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "reviewedByTherapistAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserFullSizeDto),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionFullSizeDto.prototype, "user", void 0);
//# sourceMappingURL=training-session.full-size.dto.js.map